import { StudioError } from '#~/error/index.js';
import { CalibrationActionType, calibrate } from './calibrate.js';
import type { Retry } from './types.js';

/**
 * Start device calibration.
 *
 * @param deviceId - Device ID.
 */
export const retry: Retry = async (deviceId) => {
  try {
    await calibrate(deviceId, CalibrationActionType.CALIBRATION_ACTION_RETRY);
  } catch (cause) {
    throw new StudioError('Unable to start device calibration.', { cause });
  }
};
